export const propsNamesAdapter = (itemName) => {
    // eslint-disable-next-line default-case
    switch (itemName) {
        case "photoUrl":
            return "url";
        case "photoAlt":
            return "alt";
        case "linkUrl":
            return "url";
        case "linkName":
            return "name";
        case "problemTitle":
            return "title";
        case "problemText":
            return "text";
        case "solutionName":
            return "name";
        case "solutionAuthor":
            return "author";
        case "solutionLink":
            return "link";
        case "solutionText":
            return "text";
        case "timelineDate":
            return "date";
        case "timelineFullDate":
            return "date";
        case "timelineText":
            return "text";
        case "faqQuestion":
            return "question";
        case "faqAnswer":
            return "answer";
        case "orgUrl":
            return "url";
        case "orgName":
            return "name";
        case "videoUrl":
            return "url";
        case "videoTitle":
            return "title";
        case "textTitle":
            return "title";
        case "textDescription":
            return "description";
        default:
            return itemName;
    }
};
